import { render, staticRenderFns } from "./mv.vue?vue&type=template&id=65942225&scoped=true&"
import script from "./mv.vue?vue&type=script&lang=js&"
export * from "./mv.vue?vue&type=script&lang=js&"
import style0 from "./mv.vue?vue&type=style&index=0&id=65942225&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65942225",
  null
  
)

export default component.exports